import * as React from "react";
import "./CustomSwiper.scss";
import PropTypes from "prop-types";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// Import Swiper React
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode } from "swiper";

const CustomSwiper = (props) => {
  const { slides } = props;

  return (
    <div className="swiper-container">
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={30}
        freeMode={true}
        grabCursor={true}
        modules={[FreeMode]}
        className="custom-swiper"
      >
        {slides.map((i, _i) => (
          <SwiperSlide key={_i}>
            <GatsbyImage
              className={"hey"}
              image={getImage(i)}
              alt={i.title}
              draggable={false}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

CustomSwiper.propTypes = {
  slides: PropTypes.array.isRequired,
};

export default CustomSwiper;
